import { PRODUCT_TYPES } from '../../config/app.constants';

const routes = {
  root: '/',
  base: '/e_recruiting_talent_service',
  oldBase: '/e_recruiting_sourcing_service',
  signup: '/signup',
  login: '/login',
  oldBriefingForm: `/briefing/form`,
  briefingLonglistForm: `/${PRODUCT_TYPES.longlist}/briefing/form`,
  briefingShortlistForm: `/${PRODUCT_TYPES.shortlist}/briefing/form`,
  briefingLonglistFormStep: `/${PRODUCT_TYPES.longlist}/briefing/form/:step`,
  briefingShortlistFormStep: `/${PRODUCT_TYPES.shortlist}/briefing/form/:step`,
  briefingBadFormStep: `/:type/briefing/form/:step`,
  briefingLonglistFormStep1: `/${PRODUCT_TYPES.longlist}/briefing/form/step_1`,
  briefingShortlistFormStep1: `/${PRODUCT_TYPES.shortlist}/briefing/form/step_1`,
  briefingLonglistFormStep2: `/${PRODUCT_TYPES.longlist}/briefing/form/step_2`,
  briefingShortlistFormStep2: `/${PRODUCT_TYPES.shortlist}/briefing/form/step_2`,
  briefingsDashboard: '/briefings',
  briefingDetail: '/briefings/:briefingId',
  candidateShortlist: `/briefings/:briefingId/shortlist/`,
  candidateShortlistProfile: `/briefings/:briefingId/shortlist/:candidateId`,
  candidateLonglistProfile: `/briefings/:briefingId/longlist/:candidateId`,
  onboarding: '/onboarding',
  printAllCandidates: `/briefings/:briefingId/shortlist/print/`,
  printAllCandidatesV2: `/briefings/:briefingId/shortlist-v2/print/`,
  candidateShortlistV2: `/briefings/:briefingId/shortlist-v2/`,
  productSelection: '/briefing/form/product',
  longlist: '/briefings/:briefingId/longlist',
  newBriefingForm: `/new/briefing/form`,
  newReportList: `/briefings/:briefingId/reports/`,
  newReportDetails: `/briefings/:briefingId/reports/:reportId`,
} as const;

export { routes };
